import { render } from "./ZoomView.vue?vue&type=template&id=070670b4&scoped=true"
import script from "./ZoomView.vue?vue&type=script&lang=js"
export * from "./ZoomView.vue?vue&type=script&lang=js"

import "./ZoomView.vue?vue&type=style&index=0&id=070670b4&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070670b4"]])

export default __exports__